import React, { useEffect, useState } from "react";
import { Menu, Popover } from "@arco-design/web-react";
import { SvgIcon } from "@/components/SvgIcon";
import { IconCaretDown, IconCaretUp } from "@arco-design/web-react/icon";
import "./MenuLayout.less";
import { useNavigate, useLocation } from "react-router-dom";
import store from "@/stores/authTabStore";
import { observer } from "mobx-react-lite";
import issue_text from "@/assets/images/issue-text.png";
import { v4 as uuidv4 } from "uuid";
import issue_video from "@/assets/images/issue-video.png";
import ClientTabs from "@/stores/clientTabStore";
import collectImg from "@/assets/collect/collect-m.png";
import agentUser from "@/stores/agentUser";
const MenuItem = Menu.Item;
const SubMenu = Menu.SubMenu;
export const getRouterTitle = (path) => {
  const actionMap = {
    "/matrix/webAuth": "授权管理",
    "/matrix/webAuth/info": "网页授权",
    "/matrix/helperAuth": "小助手授权",
    "/matrix/publish-works": "作品管理",
    "/matrix/task": "任务管理",
    "/matrix/videoList": "视频列表",
    "/matrix/task/info": "任务管理",
    "/matrix": "工作台",
    "/matrix/merchant": "商家管理",
    "/matrix/log": "日志",
    "/matrix/message": "私信",
    "/matrix/comment": "评论",
    "/matrix/draft": "草稿箱",
    "/matrix/collection": "合集管理",
    "/matrix/intelligent-reply": "智能回复",
    "/matrix/toolMount": "工具挂载",
    "/matrix/video-edit": "视频编辑",
  };
  return actionMap[path];
};
const MenuLayout = () => {
  const navigate = useNavigate();
  const locations = useLocation();
  const [openKeys, setOpenKeys] = useState([]);
  const [selectedKeys, setSelectedKeys] = useState([]);
  const [isLog, setIsLog] = useState<boolean>(false);
  const [caretStatus, setCaretStatus] = useState<boolean>(false);
  const onClickMenuItem = (key: string) => {
    console.log(store.isDirty, "isDirty");
    if (store.isDirty) {
      store.updateDirtyVisible(true);
      store.updateNextPath(key);
    } else {
      if (ClientTabs.isClient) {
        ClientTabs.updateTab({
          title: getRouterTitle(key),
          path: key,
          key: `${uuidv4()}`,
        });
      }
      store.updateActiveRoute(key);
      navigate(key);
    }
  };
  useEffect(() => {
    const path = locations.pathname;
    const keys1 = [
      "/matrix/webAuth",
      "/matrix/webAuth/info",
      "/matrix/helperAuth/info",
      "/matrix/helperAuth",
    ];
    const keys2 = [
      "/matrix/publish-works",
      "/matrix/task",
      "/matrix/videoList",
      "/matrix/task/info",
      "/matrix/video-edit"
    ];
    const keys3 = [
      "/matrix/message",
      "/matrix/comment",
      "/matrix/intelligent-reply",
    ]
    if (locations.pathname !== "/") {
      setSelectedKeys([locations.pathname]);
      store.updateActiveRoute(locations.pathname);
      if (locations.pathname.includes("info")) {
        setSelectedKeys([locations.pathname.slice(0, -5)]);
      }
    } else {
      setSelectedKeys(["/matrix/home"]);
      onClickMenuItem("/matrix/home");
    }

    if (keys1.includes(path)) {
      setOpenKeys(["0"]);
      return;
    }
    if (keys2.includes(path)) {
      setOpenKeys(["1"]);
      return;
    }
    if (keys3.includes(path)) {
      setOpenKeys(["2"])
    }
  }, [locations]);
  const onClickSubMenu = (key: string, openKeys: string[]) => {
    setOpenKeys(openKeys);
  };
  const handleChangeCaretStatus = () => {
    const issuePopover = document.getElementById("issue-option");
    if (caretStatus) {
      issuePopover.style.height = "0px";
      issuePopover.style.opacity = "0";
      issuePopover.style.padding = "0";
    } else {
      issuePopover.style.opacity = "1";
      issuePopover.style.padding = "10px";
      issuePopover.style.height = "122px";
    }
    setCaretStatus(!caretStatus);
  };
  const handlePublish = (type) => {
    const path = `/matrix/publish-works?key=${type}`;
    handleChangeCaretStatus();
    ClientTabs.updateTab({
      title: "发布作品",
      path: path,
      key: `${uuidv4()}`,
    });
    store.updateActiveRoute(path);
    navigate(path);
  };
  useEffect(() => {
    // Add click event listener to document
    const handleClickOutside = (e) => {
      const issuePopover = document.getElementById("issue-option");
      if (!caretStatus && issuePopover) {
        issuePopover.style.height = "0px";
        issuePopover.style.opacity = "0";
        issuePopover.style.padding = "0";
        setCaretStatus(false);
      }
    };

    document.addEventListener("click", handleClickOutside);
    setIsLog(sessionStorage.getItem("isLog") == "1");
    document.addEventListener("keydown", function (event) {
      // 使用 event.key 检测是否按下了 F12 键
      if (event.key === "F12" || event.keyCode === 123) {
        if (sessionStorage.getItem("isLog") == "1") {
          sessionStorage.setItem("isLog", "0");
          setIsLog(false);
        } else {
          sessionStorage.setItem("isLog", "1");
          setIsLog(true);
        }
      }
    });

    // Cleanup on component unmount
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);
  return (
    <div className="menu-root">
      {(agentUser.isThisAgent || process.env.REACT_APP_PLATFORM === 'ai') ? null : <div className="issue-btn">
        <div
          onClick={(e) => {
            e.stopPropagation();
            e.preventDefault();
            handleChangeCaretStatus();
          }}
        >
          <span>发布</span>
          <div className="menu-icon-svg">
            {caretStatus ? (
              <IconCaretUp fontSize={18} />
            ) : (
              <IconCaretDown fontSize={18} />
            )}
          </div>
        </div>
        <div id="issue-option">
          <div onClick={() => handlePublish("video")}>
            <img src={issue_video} alt="" />
            <span>发布视频</span>
          </div>
          <div onClick={() => handlePublish("image")}>
            <img src={issue_text} alt="" />
            <span>发布图文</span>
          </div>
        </div>
      </div>}
      <button
        className="auth-account"
        onClick={() => {
          ClientTabs.updateTab({
            title: "小助手授权",
            path: "/matrix/helperAuth",
            key: `${uuidv4()}`,
          });
          store.updateActiveRoute("/matrix/helperAuth");
          navigate("/matrix/helperAuth");
        }}
      >
        授权账号
      </button>
      <Menu
        style={{ height: "100%" }}
        onClickMenuItem={onClickMenuItem}
        openKeys={openKeys}
        selectedKeys={selectedKeys}
        onClickSubMenu={onClickSubMenu}
      >
        <MenuItem key="/matrix">
          <div className="menu-icon-svg">
            <SvgIcon width={26} height={26} name="icon-gongzuotai" />
          </div>
          工作台
        </MenuItem>
        <SubMenu
          key="0"
          title={
            <div className="submenu-title">
              <div className="menu-icon-svg">
                <SvgIcon
                  width={26}
                  height={26}
                  name="icon-zhanghaoguanliicon-"
                />
              </div>
              账号管理
            </div>
          }
        >
          <MenuItem key="/matrix/helperAuth">小助手授权</MenuItem>
          <MenuItem key="/matrix/webAuth">网页授权</MenuItem>
          <MenuItem key="/matrix/toolMount">工具挂载</MenuItem>
        </SubMenu>
        <SubMenu
          key="1"
          title={
            <div className="submenu-title">
              <div className="menu-icon-svg">
                <SvgIcon width={26} height={26} name="icon-renwu" />
              </div>{" "}
              任务管理
            </div>
          }
        >
          {/* <MenuItem key="/matrix/publish-works">发布作品</MenuItem> */}
          {process.env.REACT_APP_PLATFORM === 'ai' ? null : <MenuItem key="/matrix/task">任务列表</MenuItem>}
          <MenuItem key="/matrix/videoList">发布列表</MenuItem>
          {process.env.REACT_APP_PLATFORM === 'ai' ? null : <MenuItem key="/matrix/draft">草稿箱</MenuItem>}
        </SubMenu>
        {/* <MenuItem key="/matrix/merchant" style={{ paddingRight: "28px" }}>
          <div className="menu-icon-svg">
            <SvgIcon
              width={26}
              height={26}
              name="icon-shangjia"
              style={{ marginRight: "5px" }}
            />
          </div>
          商家管理
        </MenuItem> */}
        {/* <MenuItem key="/matrix/message" style={{ paddingRight: "40px" }}>
          <div className="menu-icon-svg">
            <SvgIcon
              style={{ marginRight: "3px" }}
              width={26}
              height={26}
              name="icon-gongzuotai"
            />
          </div>
          私信管理
        </MenuItem> */}
        <SubMenu
          key="2"
          title={
            <div className="submenu-title">
              <div className="menu-icon-svg">
                <SvgIcon
                  style={{ marginRight: "3px" }}
                  width={26}
                  height={26}
                  name="icon-gongzuotai"
                />
              </div>{" "}
              互动管理
            </div>
          }
        >
          <MenuItem key="/matrix/message">私信</MenuItem>
          <MenuItem key="/matrix/comment">评论</MenuItem>
          <MenuItem key="/matrix/intelligent-reply">智能回复</MenuItem>
        </SubMenu>
        {agentUser.isThisAgent ? null : <MenuItem key="/matrix/collection">
          <div style={{ display: "flex", alignItems: "center" }}>
            <img
              style={{ width: "24px", height: "24px", marginRight: "15px" }}
              src={collectImg}
            />
            <span>合集管理</span>
          </div>
        </MenuItem>}
        {isLog ? <MenuItem key="/matrix/log">日志</MenuItem> : null}
      </Menu>
    </div>
  );
};
export default observer(MenuLayout);
